import { useEffect, useState } from 'react';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Sankranti.scss';

const Sankranti = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [sankrantiData, setSankrantiData] = useState([]);

    // temporary values (for input fields)
  const [tempYear, setTempYear] = useState(currentYear);

    // --- Modal state ---
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const festivalTooltips = {
  "Lohri": "Lohri is a popular Punjabi festival marking the end of winter and the beginning of the harvest season. People gather around bonfires, sing traditional songs, and offer sesame seeds, jaggery, and popcorn.",
  "Maghi": "Maghi is celebrated in Punjab to honor the memory of the 40 Sikh martyrs. It is observed with religious gatherings and fairs at holy sites like Muktsar Sahib.",
  "Bhogi Pandigai": "Bhogi Pandigai is the first day of Pongal in Tamil Nadu, where old belongings are discarded and bonfires are lit, symbolizing transformation and new beginnings.",
  "Makara Sankranti": "Makara Sankranti marks the sun’s transition into Capricorn. It signifies the beginning of longer days and is celebrated with kite flying, feasts, and holy dips in rivers.",
  "Pongal": "Pongal is a Tamil harvest festival thanking the Sun God. A special dish called 'Pongal' is cooked with newly harvested rice, milk, and jaggery.",
  "Pedda Panduga": "Pedda Panduga is a traditional Telugu harvest festival where families reunite, perform rituals, and enjoy special dishes.",
  "Uttarayana": "Uttarayana marks the beginning of the sun’s northward journey. It's considered an auspicious period in Hindu tradition.",
  "Uruka": "Uruka is the eve of Magh Bihu in Assam, where communities feast together and prepare for the main Bihu celebrations.",
  "Mattu Pongal": "Mattu Pongal is a day dedicated to honoring cattle in Tamil Nadu. Cows and bulls are decorated, fed, and worshipped for their role in farming.",
  "Kanuma Panduga": "Kanuma Panduga is celebrated in Andhra Pradesh, where farmers honor their cattle and showcase them in village processions.",
  "Magh Bihu": "Magh Bihu, also known as Bhogali Bihu in Assam, is a harvest festival marked by feasting, bonfires, and community gatherings.",
  "Kaanum Pongal": "Kaanum Pongal is the final day of Pongal in Tamil Nadu. Families go on outings and pay respects to elders with blessings and gifts.",
  "Mukkanuma": "Mukkanuma is celebrated in Andhra Pradesh to worship nature, especially cattle and tools used in farming. It marks the end of the three-day Sankranti festival."
};


  // --- Long popups for modal ---
  const popups = {
    "Lohri": "Lohri is celebrated on the last day of the month of Paush. Devotees gather around a bonfire, sing traditional folk songs, and offer sesame seeds, jaggery, and popcorn to thank the Sun God for the harvest and seek blessings for prosperity. The festival also celebrates fertility, abundance, and social harmony in communities.",
    "Maghi": "Maghi commemorates the sacrifice of forty Sikh martyrs in the battle of Muktsar. Devotees take holy dips in sacred rivers, offer prayers, and participate in fairs and community events. The festival is a symbol of courage, loyalty, and spiritual devotion.",
    "Bhogi Pandigai": "Bhogi Pandigai marks the first day of Pongal, dedicated to Lord Indra. Old household items are discarded in bonfires, symbolizing letting go of the past and embracing renewal. Devotees sing songs, offer prayers, and celebrate the transformation and rejuvenation of life.",
    "Makara Sankranti": "Makara Sankranti signifies the sun's entry into Capricorn. People take holy dips in rivers, fly kites, and prepare traditional sweets like sesame laddus. The festival represents spiritual elevation, longer days, and the importance of gratitude for nature's bounty.",
    "Pongal": "Pongal is the Tamil harvest festival dedicated to the Sun God. Newly harvested rice is cooked with milk and jaggery in a clay pot until it overflows, symbolizing abundance. Devotees decorate their homes, worship cattle, and express gratitude for agricultural prosperity.",
    "Pedda Panduga": "Pedda Panduga is a Telugu harvest festival where families gather, perform rituals to honor the Sun God and farm tools, and prepare festive dishes. The event reinforces familial bonds, cultural heritage, and the celebration of nature's bounty.",
    "Uttarayana": "Uttarayana marks the northward journey of the Sun, considered highly auspicious. Devotees perform rituals, bathe in rivers, and seek blessings for health, prosperity, and spiritual growth. This period symbolizes enlightenment, stability, and positive energy in life.",
    "Uruka": "Uruka is the eve of Magh Bihu in Assam. Communities prepare for the main celebrations by feasting, lighting bonfires, and performing rituals. The festival emphasizes social cohesion, gratitude for agricultural yield, and rejuvenation of cultural traditions.",
    "Mattu Pongal": "Mattu Pongal honors cattle for their crucial role in farming. Devotees decorate cows and bulls with garlands, paint their horns, and offer special feed. The festival recognizes the symbiotic relationship between humans and animals, ensuring prosperity and harmony.",
    "Kanuma Panduga": "Kanuma Panduga is celebrated in Andhra Pradesh to honor cattle, essential for agriculture. Farmers showcase their livestock in processions, perform pujas, and thank the animals for their service. It strengthens communal participation and agricultural traditions.",
    "Magh Bihu": "Magh Bihu, or Bhogali Bihu, is a harvest festival in Assam. Communities light bonfires, prepare feasts, and organize cultural events. The festival celebrates prosperity, social bonding, and gratitude for the harvest.",
    "Kaanum Pongal": "Kaanum Pongal is the final day of Pongal in Tamil Nadu. Families visit relatives, pay respects to elders, and organize outings. The day emphasizes social bonding, gratitude, and family harmony.",
    "Mukkanuma": "Mukkanuma is celebrated in Andhra Pradesh to worship nature, farm tools, and cattle, marking the conclusion of the Sankranti festival. Devotees offer prayers and thanks for agricultural abundance, reinforcing respect for nature and sustainable farming practices."
  };

  useEffect(() => {
    const fetchSankrantiData = async () => {
      try {
        const res = await fetch(`https://core-c343.onrender.com/api/sankranti-region?year=${year}`);
        const data = await res.json();
        if (data?.months?.length) {
          setSankrantiData(data.months);
        }
      } catch (error) {
        console.error('Error fetching Sankranti data:', error);
      }
    };

    fetchSankrantiData();
  }, [year]);

    const handleSubmit = () => {
  setYear(tempYear);
};


  const handleEventClick = (eventName) => {
    setSelectedEvent(eventName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };

  return (
    <div className="sankranti-container">
      <InnerNav />

      <div className="sankranti-content">
       <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

        <h1 className="s-heading">{year} Sankranti</h1>

        {sankrantiData.map((item, index) => (
          <div className="sankranti-card" key={index}>
            <div className="card-header">{item.dayLabel}</div>

            <div className="card-body">
              <div className="s-right-section">
                <div className="s-badge">{item.dayCount}</div>
                <img
                src='https://i.pinimg.com/474x/2d/06/03/2d06037fb1c594dd889de200e1245ba0.jpg'
                  alt="Lord Surya"
                />
              </div>

              <div className="s-details">
                <div className="s-tithi">
                  <strong>Tithi:</strong> {item.tithi}
                </div>

                <ul className="s-festivals">
                  {item.festivals?.map((fest, idx) => (
                      <li key={idx} className="tooltip-wrapper">
                         <span
                        className="event-text"
                        onClick={() => handleEventClick(fest)}
                        style={{ cursor: 'pointer', textDecoration: 'underline #e71e1eff', color: '#d61414ff' }}
                      >
                        Event: {fest}
                      </span>
                        {festivalTooltips[fest] && (
                          <span className="tooltip">{festivalTooltips[fest]}</span>
                        )}
                      </li>                  
                    ))}
                </ul>

                <div className="s-timings">
                  <span>Sunrise at {item.sunrise}</span><br />
                  <span>Sunset at {item.sunset}</span>
                </div>

                {item.panchangNote && (
                  <p className="s-note"><em>{item.panchangNote}</em></p>
                )}
              </div>

              <div className="date-box">
                <div className="date">{item.date}</div>
                <div className="weekday">{item.weekday}</div>
              </div>
            </div>
          </div>
        ))}

        <CalenderLinks />
      </div>

      <Footer />
            {isModalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedEvent}</h2>
            <p>{popups[selectedEvent]}</p>
            <button className="close-btn" onClick={handleCloseModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sankranti;
